import React from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Input,
  InputNumber,
  Row,
  Select
} from 'antd';

export default function Social({ Form }) {
  return (
    <Form.List name="socials">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name }) => (
            <Row gutter={[16, 0]} key={key}>
              <Col sm={24} md={10}>
                {/* <Form.Item
                  label="Social Media Name"
                  rules={[
                    {
                      required: true,
                      message: 'Social Media Name" is required',
                    },
                  ]}
                  name={[name, 'socialName']}
                >
                  <Input placeholder="Facebook" autoFocus />
                </Form.Item> */}
				<Form.Item label="Social Media Name" name={[name, 'socialName']}
				rules={[
                    {
                      required: true,
                      message: 'Social Media Name" is required',
                    },
                  ]} >
					<Select
						allowClear
						showArrow
						style={{ width: '100%' }}
						placeholder='Facebook'
						options={[
							{
								label: 'Facebook',
								value: 'facebook',
							},
							{
								label: 'Instagram',
								value: 'instagram',
							},
							{
								label: 'Twitter',
								value: 'twitter',
							},
							{
								label: 'YouTube',
								value: 'youTube',
							},
						]}
					/>
				</Form.Item>
              </Col>
              <Col sm={24} md={10}>
                <Form.Item
                  label="Social Media Link"
                  rules={[
                    {
                      required: true,
                      message: 'Social Media Link is required',
                    },
                  ]}
                  name={[name, 'socialLink']}
                >
                  <Input
                    style={{ width: '100%' }}
                    placeholder="https://www.facebook.com/"
                  />
                </Form.Item>
              </Col>

              <Col sm={24} md={1}>
                {fields.length > 1 ? (
                  <Form.Item label="&nbsp;">
                    <Button
                      icon={<CloseOutlined />}
                      shape="circle"
                      onClick={() => remove(name)}
                    />
                  </Form.Item>
                ) : null}
              </Col>
              <Divider style={{ margin: 0, marginBottom: 16 }} />
            </Row>
          ))}
          <Row gutter={[16, 0]}>
            <Col sm={24} md={6}>
              <Form.Item>
                <Button
                  icon={<PlusOutlined />}
                  type="primary"
                  onClick={() => {
                    add();
                  }}
                  style={{ width: '100%' }}
                >
                  Add Social Media Link
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </Form.List>
  );
}



// import React, { useState, useEffect } from 'react';
// import { Link, useParams, useNavigate } from 'react-router-dom';
// import { Col, Input, Row, Select, Button, message, Space } from 'antd';
// import axios from 'axios';

// function Social({ Form }) {
//   const navigate = useNavigate();
//   const { editSocialId } = useParams();
//   const [isLoading, setIsLoading] = useState(false);
//   const [form] = Form.useForm();

//   const get = () => {
//     if (!editSocialId) {
//       return;
//     }
//     axios
//       .get('http://localhost:3001/social', { params: { _id: editSocialId } })
//       .then((response) => {
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };
//   const onSave = () => {
//     form
//       .validateFields()
//       .then((values) => {
//         setIsLoading(true);
//         if (editSocialId) {
//           values._id = editSocialId;
//         }
//         axios({
//           method: editSocialId ? 'put' : 'post',
//           url: '/social',
//           data: values,
//         })
//           .then((result) => {
//             if (result.data.success) {
//               message.success(result.data.message);
//               navigate('/social');
//             } else {
//               message.error(result.data.message);
//               setIsLoading(false);
//             }
//           })
//           .catch(() => {
//             message.error('Oops! Something went wrong!');
//             setIsLoading(false);
//           });
//       })
//       .catch((e) => {
//         console.log(e);
//       });
//   };

//   useEffect(() => {
//     get();
//   }, []);

//   return (
//     <Form.List name="socials">
//       {(fields, { add, remove }) => (
//         <>
//           {fields.map(({ key, name }) => (
//             <Row gutter={[16, 0]}>
//               <Col sm={24} md={12}>
//                 <Form.Item label="Facebook" name={[name, 'facebook']}>
//                   <Input placeholder="https://www.facebook.com/" autoFocus />
//                 </Form.Item>
//               </Col>

//               <Col sm={24} md={12}>
//                 <Form.Item label="Instagram" name={[name, 'instagram']}>
//                   <Input placeholder="https://www.instagram.com/" autoFocus />
//                 </Form.Item>
//               </Col>

//               <Col sm={24} md={12}>
//                 <Form.Item label="Twitter" name={[name, 'twitter']}>
//                   <Input placeholder="Add Link" autoFocus />
//                 </Form.Item>
//               </Col>

//               <Col sm={24} md={12}>
//                 <Form.Item label="Youtube" name={[name, 'youtube']}>
//                   <Input placeholder="https://www.youtube.com/" autoFocus />
//                 </Form.Item>
//               </Col>

//               <Col sm={24} md={12}>
//                 <Form.Item label="Blog" name={[name, 'blog']}>
//                   <Input placeholder="Add Link" autoFocus />
//                 </Form.Item>
//               </Col>

//               <Col sm={24} md={12}>
//                 <Form.Item label="Vimeo" name={[name, 'vimeo']}>
//                   <Input placeholder="https://www.vimeo.com/" autoFocus />
//                 </Form.Item>
//               </Col>
//             </Row>
//           ))}
//           <Space wrap>
//             <Button>Cancel</Button>
//             <Button type="primary" onClick={onSave}>
//               Save
//             </Button>
//           </Space>
//         </>
//       )}
//     </Form.List>
//   );
// }

// export default Social;
